// deviseのusers/xxx_controller
// webpacker.ymlのresolved_pathsに指定したプレフィックスは省略可能

// Vue.js
import Vue from "vue/dist/vue.esm";

// /components/companies
import CompanySearch from "components/companies/CompanySearch.vue";

// /components/surveys
import VStepperNewVersion from "components/surveys/VStepperNewVersion.vue";
import RequiredBadge from "components/surveys/RequiredBadge.vue";
import TextArea from "components/surveys/TextArea.vue";
import TextBox from "components/surveys/TextBox.vue";

// /components
import AdminSettingSideNav from "components/AdminSettingSideNav.vue";
import AdminSideNav from "components/AdminSideNav.vue";
import SubmitModal from "components/SubmitModal.vue";
import SingleSelectionRadiobutton from "components/SingleSelectionRadiobutton.vue";

// /components/notifications
import NotificationCount from "components/notifications/NotificationCount.vue";

export default new Vue({
  el: "#vue-app",
  components: {
    CompanySearch,
    VStepperNewVersion,
    RequiredBadge,
    TextArea,
    TextBox,
    AdminSideNav,
    SubmitModal,
    SingleSelectionRadiobutton,
    NotificationCount,
    AdminSettingSideNav
  }
});
